import "@/assets/css/card.css";
import "@/assets/css/spacing.css";
import "@/assets/css/style.css";
import "@paydeck-ui/styles/tokens.css";
import "@/assets/css/site.css";
import "@/assets/css/refine.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

createApp(App).use(router).mount("#app");
